import { createAction } from '@src/redux/helpers/createAction';
import {
  TIN_STATUS,
  TIN_SUBMISSION,
  UPLOAD_DOCUMENT,
  SET_DOCUMENT_ID,
  SET_DOCUMENT_LOADING,
  SET_TRACKING_NUMBER,
  SET_SIGNATURE_CANVAS,
  SAVE_AS_DRAFT,
  RETRIEVE_DRAFT,
  DELETE_SESSION,
  RETURN_TO_REGISTRATION,
  NPI_VALIDATIONS,
  DISABLE_SAVEASDRAFT,
} from './constants';
import {
  getTinStatus,
  tinSubmission,
  uploadDocument,
  uploadSignatureRequest,
  callSaveAsDraft,
  getDraft,
  deleteDraft,
  npiValidations,
} from './requests';

export const fetchTinStatus = (query, onSuccess, onError) => {
  return createAction({
    type: TIN_STATUS,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: getTinStatus,
    },
  });
};

export const uploadProof = (query, onSuccess, onError) => {
  return createAction({
    type: UPLOAD_DOCUMENT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: uploadDocument,
    },
  });
};

export const uploadSignature = (query, onSuccess, onError) => {
  return createAction({
    type: UPLOAD_DOCUMENT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: uploadSignatureRequest,
    },
  });
};

export const setDocumentId = (query) => {
  return createAction({
    type: SET_DOCUMENT_ID,
    payload: query,
  });
};

export const setDocumentLoading = (query) => {
  return createAction({
    type: SET_DOCUMENT_LOADING,
    payload: query,
  });
};

export const setTrackingNumber = (query) => {
  return createAction({
    type: SET_TRACKING_NUMBER,
    payload: query,
  });
};

export const submitTin = (query, onSuccess, onError) => {
  return createAction({
    type: TIN_SUBMISSION,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: tinSubmission,
    },
  });
};

export const setSignatureCanvas = (query) => {
  return createAction({
    type: SET_SIGNATURE_CANVAS,
    payload: query,
  });
};

export const saveAsDraft = (query, onSuccess, onError) => {
  return createAction({
    type: SAVE_AS_DRAFT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: callSaveAsDraft,
    },
  });
};

export const retrieveDraft = (query, onSuccess, onError) => {
  return createAction({
    type: RETRIEVE_DRAFT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: getDraft,
    },
  });
};

export const deleteSession = (query, onSuccess, onError) => {
  return createAction({
    type: DELETE_SESSION,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: deleteDraft,
    },
  });
};

export const toggleReturnRegistration = (query) => {
  return createAction({
    type: RETURN_TO_REGISTRATION,
    payload: query,
  });
};

export const validateNPI = (query, onSuccess, onError) => {
  return createAction({
    type: NPI_VALIDATIONS,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: npiValidations,
    },
  });
};

export const disableSaveAsDraft = (query) => {
  return createAction({
    type: DISABLE_SAVEASDRAFT,
    payload: query,
  });
};
